import Link from 'next/link'

export default function MyLink({ href = '/', children, openNewTab = false, className, as, ...props }) {
  let linkProps = {
    className,
    ...props,
  }

  if (openNewTab) {
    linkProps = {
      ...linkProps,
      target: '_blank',
      rel: 'noopener noreferrer',
    }
  }

  return (
    <Link href={href} as={as} prefetch={false}>
      <a {...linkProps}>{children}</a>
    </Link>
  )
}
